<template>
    <Breadcrumbs main="Ui Kits" title="Avatars" />
    <div class="container-fluid">
        <div class="user-profile">
            <div class="row">
                <avatarSize />
                <avatarStatus />
                <avatarShapes />
                <avatarRatio />
                <avatarGrouping />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const avatarSize = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarSize.vue"))
const avatarStatus = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarStatus.vue"))
const avatarShapes = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarShapes.vue"))
const avatarRatio = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarRatio.vue"))
const avatarGrouping = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarGrouping.vue"))
</script>